import gravatarUrl from "gravatar-url";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logoImage from "../../assets/images/chat.png";
import { userLoggedOut } from "../../features/auth/authSlice";

export default function Navigation() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth) || {};

  const logout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();
  };
  return (
    <nav className="border-general sticky top-0 z-40 border-b bg-slate-900 transition-colors">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="flex gap-3 items-center">
            <img className="h-10" src={logoImage} alt="Learn with Sumit" />
            <span className="text-white font-bold">Chat App</span>
          </Link>
          <ul className="flex items-center gap-5 text-white">
            <li className="bg-rose-600 hover:bg-rose-700 px-2 py-1 text-center rounded">
              <span className="cursor-pointer" onClick={logout}>
                LOGOUT
              </span>
            </li>
            <li className="font-bold">{user.name}</li>
            <li>
              <img
                className="object-cover w-10 h-10 rounded-full"
                src={gravatarUrl(user.email, {
                  size: 80,
                })}
                alt={user.name}
              />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
